let displayEnv = 'LOCAL';

export const nodeEnv = (process.env.REACT_APP_ENV || '').toLowerCase();

if (nodeEnv === 'development') {
    displayEnv = 'DEVELOPMENT';
}
if (nodeEnv === 'qat') {
    displayEnv = 'QAT';
}
if (nodeEnv === 'staging') {
    displayEnv = 'STAGE';
}
if (nodeEnv === 'production') {
    displayEnv = '';
}

export const API_BASE = process.env.REACT_APP_URL;
export const LOGIN_URL = process.env.REACT_APP_MY_ID_START_SSO_URL;

export const ENDPOINTS_KEYS = {
    login: LOGIN_URL,
};

export const current_env = displayEnv;

export const LOCAL_STORAGE_KEYS = {
    main: 'cp-clearances-ui',
    activeUser: 'userId',
    token: 'access-token',
    activeUserRole: 'roles',
};

export const SUPPORTED_ROLES = ['Admin', 'Observer'];

export const LICENSE_KEY =
    'CompanyName=Zones LLC_on_behalf_of_Disney Worldwide Shared SR,LicensedGroup=Disney-CPE,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=2,AssetReference=AG-034073,SupportServicesEnd=31_January_2024_[v2]_MTcwNjY1OTIwMDAwMA==cca4bf4e5146e359f30d98519d653f14';


const appName = process.env.REACT_APP_NAME || 'clearances';
const platform = 'web';
const version = process.env.version || '0.0.1';

const SNOWPLOW_CONFIG = {
    env: displayEnv,   
    appName: appName, 
    appId: `${appName}-${platform}-${nodeEnv}-${version}`.toUpperCase(),
}

export { SNOWPLOW_CONFIG };
